import { render, staticRenderFns } from "./Headers.vue?vue&type=template&id=79b08998&scoped=true&"
import script from "./Headers.vue?vue&type=script&lang=ts&"
export * from "./Headers.vue?vue&type=script&lang=ts&"
import style0 from "./Headers.vue?vue&type=style&index=0&id=79b08998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b08998",
  null
  
)

export default component.exports